import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
import { TtsService } from './TtsService';
import { supabase } from '../supabase/supabase';

/**
 * Azure AI Speech Implementation
 */
export class AzureTtsService extends TtsService {
  constructor() {
    super();
    this.token = null;
    this.region = null;
    this.tokenExpiry = 0;
  }

  async _refreshToken() {
    const now = Date.now();
    // Token is valid for 10 minutes, refresh at 9 minutes
    if (this.token && now < this.tokenExpiry) {
      return;
    }

    try {
      const { data, error } = await supabase.functions.invoke('get-azure-speech-token');
      if (error || !data?.token) {
        throw new Error(error?.message || 'Failed to get token');
      }
      this.token = data.token;
      this.region = data.region;
      this.tokenExpiry = now + (9 * 60 * 1000); // 9 minutes
    } catch (err) {
      console.error('Azure Token Refresh Error:', err);
      throw err;
    }
  }

  async speak(text, options = {}) {
    const { voice = 'ja-JP-NanamiNeural' } = options;

    try {
      await this._refreshToken();

      const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(this.token, this.region);
      speechConfig.speechSynthesisVoiceName = voice;

      const audioConfig = SpeechSDK.AudioConfig.fromDefaultSpeakerOutput();
      const synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

      return new Promise((resolve, reject) => {
        synthesizer.speakTextAsync(
          text,
          result => {
            if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
              resolve();
            } else {
              reject(new Error(`Azure TTS Error: ${result.errorDetails}`));
            }
            synthesizer.close();
          },
          err => {
            synthesizer.close();
            reject(err);
          }
        );
      });
    } catch (err) {
      console.error('AzureTtsService Error:', err);
      throw err;
    }
  }
}
